/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  FORGOT_PASSWORD_BANNER_ERROR_HEADING: 'forgotPassword.bannerError.heading',
  FORGOT_PASSWORD_BANNER_ERROR_LINK_LABEL: 'forgotPassword.bannerError.link.label',
  FORGOT_PASSWORD_ERROR_GENERIC_MESSAGE: 'forgotPassword.error.genericMessage',
  FORGOT_PASSWORD_FORM_HEADING: 'forgotPassword.form.heading',
  FORGOT_PASSWORD_FORM_PARAGRAPH: 'forgotPassword.form.paragraph',
  FORGOT_PASSWORD_INITIATE_ERROR_HEADING: 'forgotPassword.initiate.error.heading',
  FORGOT_PASSWORD_INITIATE_ERROR_LINK_LABEL: 'forgotPassword.initiate.error.link.label',
  FORGOT_PASSWORD_INITIATE_SUCCESS_HEADING: 'forgotPassword.initiate.success.heading',
  FORGOT_PASSWORD_INITIATE_SUCCESS_LINK_LABEL: 'forgotPassword.initiate.success.link.label',
  FORGOT_PASSWORD_INITIATE_SUCCESS_PARAGRAPH: 'forgotPassword.initiate.success.paragraph',
  FORGOT_PASSWORD_RESET_PASSWORD_HEADING: 'forgotPassword.resetPassword.heading',
  FORGOT_PASSWORD_SERVICE_ERROR_HEADING: 'forgotPassword.serviceError.heading',
  FORGOT_PASSWORD_SERVICE_ERROR_LINK_LABEL: 'forgotPassword.serviceError.link.label',
  FORGOT_PASSWORD_VERIFY_ERROR_HEADING: 'forgotPassword.verify.error.heading',
  FORGOT_PASSWORD_VERIFY_ERROR_LINK_LABEL: 'forgotPassword.verify.error.link.label',
  FORGOT_PASSWORD_VERIFY_SUCCESS_HEADING: 'forgotPassword.verify.success.heading',
  FORGOT_PASSWORD_VERIFY_SUCCESS_LINK_LABEL: 'forgotPassword.verify.success.link.label',
};

const enMessages = {
  [IDS.FORGOT_PASSWORD_BANNER_ERROR_HEADING]: 'We are unable to register your loan at this time',
  [IDS.FORGOT_PASSWORD_BANNER_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.FORGOT_PASSWORD_ERROR_GENERIC_MESSAGE]: 'An error has occurred while attempting to retrieve your password. Please try again later. If the issue continues to persist, please call Customer Service for assistance.',
  [IDS.FORGOT_PASSWORD_FORM_HEADING]: 'Forgot your password?',
  [IDS.FORGOT_PASSWORD_FORM_PARAGRAPH]: 'Don\'t worry, we can help you recover your account information.',
  [IDS.FORGOT_PASSWORD_INITIATE_ERROR_HEADING]: 'Forgot Password - Error',
  [IDS.FORGOT_PASSWORD_INITIATE_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.FORGOT_PASSWORD_INITIATE_SUCCESS_HEADING]: 'Recovery email sent. Check your email',
  [IDS.FORGOT_PASSWORD_INITIATE_SUCCESS_LINK_LABEL]: 'Return to Login',
  [IDS.FORGOT_PASSWORD_INITIATE_SUCCESS_PARAGRAPH]: 'If the username you entered is associated with an account in our records, you will receive an email from <b>noreply@yourmortgageonline.com</b> with instructions for resetting your password. Please add <b>noreply@yourmortgageonline.com</b> to your safe senders list. If you do not receive this email, please contact customer service for assistance at <a>1-800-669-4268</a>.',
  [IDS.FORGOT_PASSWORD_RESET_PASSWORD_HEADING]: 'Create a new password',
  [IDS.FORGOT_PASSWORD_SERVICE_ERROR_HEADING]: 'Forgot Password - Error',
  [IDS.FORGOT_PASSWORD_SERVICE_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.FORGOT_PASSWORD_VERIFY_ERROR_HEADING]: 'Forgot Password - Error',
  [IDS.FORGOT_PASSWORD_VERIFY_ERROR_LINK_LABEL]: 'Return to Login',
  [IDS.FORGOT_PASSWORD_VERIFY_SUCCESS_HEADING]: 'Success!\nYour password has been reset',
  [IDS.FORGOT_PASSWORD_VERIFY_SUCCESS_LINK_LABEL]: 'Return to Login',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.FORGOT_PASSWORD_BANNER_ERROR_HEADING]: 'We are unable to register your Murabaha Financing Transaction at this time',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
